module.exports = __webpack_public_path__ + "static/media/logo_blueroad.ba00c8e9.png";